import React from "react";
import { useAuth0 } from './useAuth0';
import { Navigate } from "react-router-dom";
import LoadInitialData from "./LoadInitialData";

const PrivateRoute = ({ element }: { element: JSX.Element }) => {
    const { isAuthenticated, isLoading } = useAuth0();

    if (isLoading) {
        return <div data-cy="auth-loading">Loading...</div>;
    }
    console.log('PrivateRoute.ts - redirect to ', isAuthenticated);
    // if(isAuthenticated) {
    //     return (
    //         <>
    //             <LoadInitialData />
    //             {element}
    //         </>
    //     );
    // }else{
    //     return <Navigate to="/auth-redirect" />
    // }
    return isAuthenticated ? element : <Navigate to="/auth-redirect" />;
};

export default PrivateRoute;